import { tagInteractiveElements } from './clickListener'
let timeout = 5000

export const setLoadTimeout = value => {
  timeout = value
}

export const recordPageView = (pageInfoKey, options) => {
  makeBactmCall(() => {
    window.bactm.pageview(pageInfoKey, options)
  })
}

export const recordClick = (href, linkname) => {
  makeBactmCall(() => {
    window.bactm.manualLinkClick(href, linkname)
  })
}

export const recordConversion = (type, payload) => {
  makeBactmCall(() => {
    window.bactm.conversion(type, payload)
  })
}

export const recordCustomEvent = (type, payload) => {
  makeBactmCall(() => {
    window.bactm.customEvent(type, payload)
  })
}

export const recordCustomError = (errorCode, errorMessage) => {
  makeBactmCall(() => {
    window.bactm.customError(errorCode, errorMessage)
  })
}

export const setPageId = ({ pageId, pagename, category }, callback) => {
  isBactmReady()
    .then(() => {
      if (!window.bactm.ddo.get(`disable_pageviewonload`)) {
        console.error(`setPageId should not be used if disable_pageviewonload is false.`)
      }

      const separator = `;`
      if (pageId && !pageId.includes(separator)) {
        console.error(`setPageId pageId parameter does not include the separator character '${separator}'.`)
      }
      const pageInfo = window.bactm.ddo.pageInfo.get()
      const key = `pageID`
      if (!pageId) {
        const [oldCategory, oldPagename] = pageInfo[key].split(separator)
        const newCategory = category || oldCategory
        const newPagename = pagename || oldPagename
        pageId = `${newCategory}${separator}${newPagename}`
      }

      pageInfo[key] = pageId
      window.bactm.ddo.pageInfo.set(pageInfo)

      if (callback) {
        callback()
      }
    })
}

export const refreshTrackingIds = () => {
  tagInteractiveElements()
  makeBactmCall(() => {
    window.bactm.rescanDOM()
  })
}

const makeBactmCall = callback => {
  isBactmReady()
    .then(() => {
      callback()
    })
    .catch(error => {
      console.log(error)
    })
}

const isBactmReady = () => {
  return new Promise((resolve, reject) => {
    if (window.bactm) resolve()

    const checkForBactmInterval = setInterval(() => {
      if (window.bactm) {
        clearInterval(checkForBactmInterval)
        resolve()
      }
    }, 10)
    
    window.setTimeout(() => {
      if (checkForBactmInterval) {
        clearInterval(checkForBactmInterval)
        reject(new Error('Bactm not found'))
      }
    }, timeout)

  })
}
